
export default function WhyChooseUsSection() {
  const features = [
    {
      icon: 'ri-award-line',
      title: 'Professional Coaches',
      description: 'Licensed and experienced coaches with proven track records in youth development.'
    },
    {
      icon: 'ri-team-line',
      title: 'Small Class Sizes',
      description: 'Maximum 12 players per group ensuring personalized attention for every child.'
    },
    {
      icon: 'ri-shield-check-line',
      title: 'Safe Environment',
      description: 'Fully insured facility with safety protocols and first aid certified staff.'
    },
    {
      icon: 'ri-trophy-line',
      title: 'Proven Results',
      description: 'Over 200 players developed with many advancing to high school and college teams.'
    },
    {
      icon: 'ri-calendar-line',
      title: 'Flexible Scheduling',
      description: 'Multiple training times throughout the week to fit your family\'s schedule.'
    },
    {
      icon: 'ri-heart-line',
      title: 'Character Building',
      description: 'Focus on sportsmanship, teamwork, and personal growth beyond just soccer skills.'
    }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">Why Choose NextZen?</h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            We're committed to providing the best soccer education experience for your child.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {features.map((feature, index) => (
            <div key={index} className="text-center p-6 rounded-xl hover:bg-gray-50 transition-colors duration-200">
              <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className={`${feature.icon} text-2xl text-blue-600`}></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-3">{feature.title}</h3>
              <p className="text-gray-600">{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
